import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import GameQuestionForm from "../../../components/admin/game/GameQuestionForm";
import { createAdminGameQuestion } from "../../../features/game/gameApi";
import cls from "./GameQuestionEditorPage.module.scss";

export default function AddGameQuestionPage() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (payload) => {
    setLoading(true);
    try {
      await createAdminGameQuestion(payload);
      nav("/admin/game-questions");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={cls.page}>
      <h1>Add Game Question</h1>
      <GameQuestionForm submitLabel="Create Question" loading={loading} onSubmit={handleSubmit} />
      <Link className={cls.backBtn} to="/admin/game-questions">Back to Questions</Link>
    </div>
  );
}